const RenderHtmlContent = ({ message }) => {
  return <div className="tvp-chat-style" dangerouslySetInnerHTML={{ __html: message }}></div>;
};

export default RenderHtmlContent;
